import { useEffect, useRef, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const DREMPEL = 80;
const MAX = 120;

// Native pull-to-refresh ontbreekt op iPhone en in de geïnstalleerde app (standalone)
const nodigOpDitApparaat = () => {
  const ua = navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const standalone = window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
  return isIOS || standalone;
};

const binnenScrollbaarElement = (el) => {
  while (el && el !== document.body) {
    if (el.scrollTop > 0) return true;
    el = el.parentElement;
  }
  return false;
};

export const PullToRefresh = () => {
  const [afstand, setAfstand] = useState(0);
  const [bezig, setBezig] = useState(false);
  const startY = useRef(null);
  const afstandRef = useRef(0);

  useEffect(() => {
    if (!nodigOpDitApparaat()) return undefined;

    const onStart = (e) => {
      if (window.scrollY > 0 || e.touches.length !== 1) return;
      if (document.querySelector('[role="dialog"], [data-state="open"][role="menu"]')) return;
      if (binnenScrollbaarElement(e.target)) return;
      startY.current = e.touches[0].clientY;
    };
    const onMove = (e) => {
      if (startY.current === null) return;
      const dy = e.touches[0].clientY - startY.current;
      if (dy <= 0 || window.scrollY > 0) {
        startY.current = null;
        afstandRef.current = 0;
        setAfstand(0);
        return;
      }
      const d = Math.min(MAX, dy * 0.5);
      afstandRef.current = d;
      setAfstand(d);
    };
    const onEnd = () => {
      if (startY.current === null) return;
      startY.current = null;
      if (afstandRef.current >= DREMPEL) {
        setBezig(true);
        setAfstand(DREMPEL);
        setTimeout(() => window.location.reload(), 150);
      } else {
        setAfstand(0);
      }
      afstandRef.current = 0;
    };

    window.addEventListener('touchstart', onStart, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onEnd);
    window.addEventListener('touchcancel', onEnd);
    return () => {
      window.removeEventListener('touchstart', onStart);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onEnd);
      window.removeEventListener('touchcancel', onEnd);
    };
  }, []);

  if (afstand <= 0 && !bezig) return null;
  const klaar = afstand >= DREMPEL;

  return (
    <div
      className="fixed left-1/2 z-[9999] pointer-events-none"
      style={{ top: 8, transform: `translate(-50%, ${afstand - 40}px)`, transition: startY.current === null ? 'transform 0.2s' : 'none' }}
      data-testid="pull-to-refresh-indicator"
    >
      <div className={`w-10 h-10 rounded-full shadow-lg flex items-center justify-center ${klaar ? 'bg-blue-600 text-white' : 'bg-white text-blue-600'}`}>
        <RefreshCw
          className={`w-5 h-5 ${bezig ? 'animate-spin' : ''}`}
          style={bezig ? undefined : { transform: `rotate(${afstand * 3}deg)` }}
        />
      </div>
    </div>
  );
};

export default PullToRefresh;
